import React, { useRef } from "react";

import closeIcon from "../../../images/icon-trash.svg";

type FileListItem = {
  FileName: string;
  ContentType: string;
  Content: string;
};

type SupportingDocumentFileSelectProps = {
  value: FileListItem[];
  onChange: (files: FileListItem[]) => void;
};

export function SupportingDocumentsFileSelect({
  value,
  onChange,
}: SupportingDocumentFileSelectProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  console.log("Here is the file", value);

  const handleSelectFile = (file: File) => {
    if (file != null)
      parseInBase64(file).then((base64) => {
        const newFile: FileListItem = {
          FileName: file.name,
          ContentType: file.type,
          Content: base64,
        };
        onChange([...value, newFile]);
      });
  };

  const handleDeleteUploadedFile = (index: number) => {
    const newArray = [...value];
    newArray.splice(index, 1);
    onChange(newArray);
  };

  return (
    <div className="form-group" style={{ width: 480 }}>
      <label style={{ fontWeight: "bold" }}>
        Submit Bind Request to enter Payment Details
      </label>
      <label>Supporting Documents (optional): </label>
      {value && value.length > 0 && (
        <div className="uploaded-files">
          {value.map((file, index) => (
            <div key={index} className="file-label">
              <span className="file-name">{file.FileName}</span>
              <div className="progress-control">
                <img
                  src={closeIcon}
                  alt=""
                  onClick={() => handleDeleteUploadedFile(index)}
                />
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="portal-file">
        {/* Explain the key on input */}
        <input
          style={{ display: "none" }}
          type="file"
          id="customFile"
          ref={inputRef}
          key={new Date().toString()}
          onChange={(e) => {
            if (e && e.target && e.target.files && e.target.files.length > 0) {
              const firstFile = e.target.files[0];
              handleSelectFile(firstFile);
            }
          }}
        />
        <div
          className="btn btn-default"
          onClick={() => inputRef.current && inputRef.current.click()}
        >
          Add File
        </div>
      </div>
    </div>
  );
}

function parseInBase64(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
}
